import React from 'react';
import PropTypes from 'prop-types';

const Search = props => {
    const { className, style } = props;

    return (
        <svg
            className={className}
            style={style}
            width="26px"
            height="25px"
            viewBox="0 0 26 25"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g id="layout" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="main_dark"
                    transform="translate(-1096.000000, -477.000000)"
                    fillRule="nonzero"
                >
                    <g id="search" transform="translate(1096.888889, 477.000000)">
                        <path
                            d="M15.9641481,16.3121317 C15.8571734,16.3122563 15.7545681,16.2697045 15.6790782,16.1939095 L14.6300576,15.1453498 C14.4725542,14.9878464 14.4725542,14.7324829 14.6300576,14.5749794 C14.787561,14.417476 15.0429246,14.417476 15.200428,14.5749794 L16.2494486,15.6246914 C16.3647044,15.7400286 16.399169,15.9134206 16.336782,16.0640674 C16.274395,16.2147141 16.1274325,16.3129721 15.9643786,16.3130535 L15.9641481,16.3121317 Z"
                            id="Path"
                            fill="#2A977F"
                        />
                        <path
                            d="M8.76019753,-4.08562073e-14 C13.5677749,-4.08562073e-14 17.4650864,3.89731151 17.4650864,8.70488889 C17.4650864,13.5124663 13.5677749,17.4097778 8.76019753,17.4097778 C3.95262015,17.4097778 0.055308642,13.5124663 0.055308642,8.70488889 C0.055308642,3.89731151 3.95262015,-4.08562073e-14 8.76019753,-4.08562073e-14 Z M8.76019753,1.50070782 C4.78143819,1.50070782 1.55601646,4.72612955 1.55601646,8.70488889 C1.55601646,12.6836482 4.78143819,15.90907 8.76019753,15.90907 C12.7389569,15.90907 15.9643786,12.6836482 15.9643786,8.70488889 C15.9643786,4.72612955 12.7389569,1.50070782 8.76019753,1.50070782 Z"
                            id="Combined-Shape"
                            fill="#CCDBDB"
                        />
                        <circle
                            id="Oval"
                            fill="#C6E4ED"
                            opacity="0.465076265"
                            cx="8.76019753"
                            cy="8.70488889"
                            r="7.20418107"
                        />
                        <path
                            d="M19.877222,14.2869935 C20.7319388,14.2869935 21.4248237,14.9798784 21.4248237,15.8345952 L21.4248237,23.8183441 C21.4248237,24.6730609 20.7319388,25.3659458 19.877222,25.3659458 C19.0225052,25.3659458 18.3296204,24.6730609 18.3296204,23.8183441 L18.3296204,15.8345952 C18.3296204,14.9798784 19.0225052,14.2869935 19.877222,14.2869935 Z"
                            id="Rectangle"
                            fill="#3BBC9F"
                            transform="translate(19.877222, 19.826470) rotate(-45.000000) translate(-19.877222, -19.826470) "
                        />
                        <path
                            d="M16.4036214,15.6016461 C16.4657538,15.8921175 16.610621,16.1584009 16.8207407,16.3683621 L22.4668313,22.0144527 C22.9274525,22.4745852 23.6268923,22.597024 24.216428,22.3207243 C24.154308,22.0302483 24.0094391,21.7639616 23.7993086,21.5540082 L18.1532181,15.9079177 C17.692564,15.4478484 16.9931665,15.325417 16.4036214,15.6016461 L16.4036214,15.6016461 Z"
                            id="Path"
                            fill="#44D7B6"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

Search.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
};

Search.defaultProps = {
    className: undefined,
    style: undefined,
};

export default Search;
